import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRoleAccent } from '../data/map';

const UserContext = createContext();
export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUserState] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  // Default accent until we know who's logged in; then follows the user's
  // role/brand (IGLU orange, Client blue, staff role colour).
  const [homeAccent, setHomeAccent] = useState('#22d3ee');
  const routes = ['/', '/index', '/validlogin'];

  // Wrap setUser so any login/refresh path re-syncs the accent automatically
  const setUser = (u) => {
    setUserState(u);
    if (u) setHomeAccent(getRoleAccent(u));
  };

  useEffect(() => {
    if (routes.includes(location.pathname)) {
      setLoading(false);
      return;
    }
    if (!user) {
      fetch('/api/user/profile', { credentials: 'include' })
        .then((res) => {
          if (!res.ok) throw new Error('Not authenticated');
          return res.json();
        })
        .then((data) => setUser(data.user))
        .catch(() => setUserState(null))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, loading, homeAccent, setHomeAccent }}>
      {children}
    </UserContext.Provider>
  );
};